/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */
import * as React from 'react';
import { Paths } from '../../../../common/enums/Paths';
import { LogCategory } from '../../../../logger';
import { newGuid } from '../../../../utilities/AppUtils';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { toQueryString } from '../../../../utilities/Utils';
import { Spinner } from '../../../components';

declare const ADOBE_CLIENT_ID: string;
declare const ADOBE_AUTH_URL: string;

const adobeAuthApi = ADOBE_AUTH_URL + '/public/oauth/v2';

export const AuthLoginStart = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    const locale = getAppHost().getLocale().getCurrentLocale();
    logger.logTraceInfo(LogCategory.AdobeAuth, 'Calling AuthLoginStart');

    const loginState = newGuid();
    localStorage.setItem('login.state', loginState);
    const adobeAuthQueryParams = {
        redirect_uri: window.location.origin + Paths.BasePath + Paths.AdobeLoginEnd,
        response_type: 'code',
        client_id: ADOBE_CLIENT_ID,
        state: loginState,
        locale: locale.replace('-', '_'),
        scope: 'user_login user_read user_write agreement_read agreement_write agreement_send webhook_read webhook_write library_read library_write',
    };

    const authorizeEndpoint = `${adobeAuthApi}?${toQueryString(adobeAuthQueryParams)}`;

    window.location.assign(authorizeEndpoint);

    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
